module.exports = __webpack_public_path__ + "images/icons/flags/ID-fe301dbd.svg";